<template>
  <div class="user-detail-layout">
    <a-card :bordered="false">
      <a-row type="flex">
        <a-col :span="12">
          <div class="detail-status">
            <h4 style="font-weight: 700;">{{$t("descriptions.accountStatus")}}</h4>
            <div>
              {{$t('form.userDetail.accountStatus.account')}}：
              <span>{{userInfo.phone}}</span>
            </div>
            <div>
              <span>{{userInfo.name}}</span>
              <a-tag
                color="blue"
                style="border-radius:50px;margin-left:20px"
              >{{$t('form.userDetail.accountStatus.subAccount')}}</a-tag>
            </div>
            <div>
              {{$t('table.common.thead.createTime')}}：
              <span>{{userInfo.create_time}}</span>
            </div>
            <div>
              {{$t('form.userDetail.accountStatus.edition')}}：
              <span>{{userInfo.expire_time}}</span>
              {{$t('form.userDetail.accountStatus.expire')}}
            </div>
            <a-button type="primary" @click="renew">{{$t("actionTitles.renew")}}</a-button>
          </div>
        </a-col>
        <a-col :span="12">
          <a-row type="flex" align="middle" justify="center">
            <div class="detail-capacity" style="width:253px;">
              <h5>{{$t("descriptions.totalSpaceCapacity")}}</h5>
              <div class="detail-capacity-icon">
                <a-progress :percent="userInfo.progress" :show-info="false" />
                <a
                  class="detail-capacity-increase"
                  @click="addCapacity"
                >{{$t('form.userDetail.spaceCapacity.increaseCapacity')}}</a>
              </div>
              <div class="detail-capacity-count">
                <span>{{userInfo.g_use_capacity}}G/{{userInfo.g_capacity}}G</span>
              </div>
            </div>
          </a-row>
        </a-col>
      </a-row>
    </a-card>

    <div style="margin-top:20px" class="user-detail-info">
      <a-card :bordered="false">
        <h4>{{$t("moduleTitles.basicInfo")}}</h4>
        <a-form-model layout="vertical" :model="form" ref="ruleForm" :rules="rules">
          <a-form-model-item
            ref="mobile"
            :label="$t('form.userDetail.form.field.mobile.label')"
            prop="phone"
            :wrapperCol="{span:10}"
          >
            <a-input
              :placeholder="$t('form.userDetail.form.field.mobile.placeholder')"
              class="user-info-mobile"
              v-model="form.phone"
            />
            <span class="user-info-id">
              {{$t('form.userDetail.form.field.mobile.userId')}}：
              <span>{{form.id}}</span>
            </span>
          </a-form-model-item>
          <a-form-model-item
            ref="linkman"
            :label="$t('form.userDetail.form.field.contact.label')+'：'"
            prop="linkman"
            :wrapperCol="{span:10}"
          >
            <a-input
              :placeholder="$t('form.userDetail.form.field.contact.placeholder')"
              v-model="form.linkman"
            />
          </a-form-model-item>

         <a-form-model-item has-feedback :label="$t('form.user.field.childLimit.label')" prop="child_limit" :wrapperCol="{span:10}">
            <a-input-number v-model="form.child_limit" :placeholder="$t('form.user.field.childLimit.message')"/>
          </a-form-model-item>

          <!-- <a-form-model-item :wrapperCol="{span:10}" :label="$t('form.common.field.company.label')+'：'">
            <a-select
              v-model="form.company"
              label-in-value
              :default-value="{ key: 0 }"
              :placeholder="$t('form.common.field.company.message')"
            >
              <a-select-option value="1">成都總公司</a-select-option>
              <a-select-option value="2">南京分公司</a-select-option>
            </a-select>
          </a-form-model-item>-->
          <a-form-model-item
            ref="region"
            :label="$t('form.userDetail.form.field.region.label')+'：'"
            :wrapperCol="{span:10}"
          >
            <h-region-select @regionData="selectedData" :defaultValue="defaultValue"></h-region-select>
          </a-form-model-item>
          <a-form-model-item
            ref="address"
            :label="$t('form.userDetail.form.field.address.label')+'：'"
            prop="address"
            :wrapperCol="{span:10}"
          >
            <a-input
              v-model="form.address"
              type="textarea"
              :placeholder="$t('form.userDetail.form.field.address.placeholder')"
              @blur="()=>{$refs.address.onFieldBlur()}"
            />
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            :label="$t('form.common.field.briefIntroduction.label')"
            :wrapperCol="{span:10}"
          >
            <a-textarea
              v-model="form.brief"
              :placeholder="$t('form.common.field.briefIntroduction.placeholder')"
              allow-clear
            />
          </a-form-model-item>
          <a-form-model-item
            :wrapperCol="{span:10}"
            :label="$t('form.common.field.gender.label')+'：'"
          >
            <a-radio-group v-model="form.gender">
              <a-radio :value="1">{{$t('enum.gender.male')}}</a-radio>
              <a-radio :value="0">{{$t('enum.gender.female')}}</a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item
            ref="wechat"
            :label="$t('form.userDetail.form.field.line.label')+'：'"
            prop="wechat"
            :wrapperCol="{span:10}"
          >
            <a-input
              :placeholder="$t('form.userDetail.form.field.line.placeholder')"
              v-model="form.wechat"
            />
          </a-form-model-item>
          <a-form-model-item
            ref="email"
            :label="$t('form.userDetail.form.field.email.label')+'：'"
            prop="email"
            :wrapperCol="{span:10}"
          >
            <a-input
              v-model="form.email"
              :placeholder="$t('form.userDetail.form.field.email.placeholder')"
            />
          </a-form-model-item>
          <a-form-model-item
              has-feedback
              :label="$t('form.common.field.store_type.label')"
              prop="store_type"
          >
            <a-select v-model="form.store_type" style="width: 120px" @change="handleChangeBrand">
              <a-select-option v-for="typeItem in storeTypeArr" :value="typeItem.value" :index="typeItem.value">{{typeItem.label}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
              has-feedback
              :label="$t('form.common.field.store_id.label')"
              prop="store_id"
          >
            <a-input
                v-model="form.store_id"
                :placeholder="$t('form.common.field.store_id.placeholder')"
            />
          </a-form-model-item>
          <footer class="ant-modal-footer">
            <div>
              <button type="button" class="ant-btn ant-btn-primary" @click="handleSubmit">
                <span>{{$t('actionTitles.submit')}}</span>
              </button>
              <!-- <button type="button" class="ant-btn" @click="onCancel">
                <span>{{$t('message.cancel')}}</span>
              </button>-->
            </div>
          </footer>
        </a-form-model>
      </a-card>
    </div>
    <pay-model :userId="userId" :visible="renewVisible" @close="renewVisible = false"></pay-model>
    <storage-pay-model :userId="userId" :visible="storageVisible" @close="storageVisible = false"></storage-pay-model>
  </div>
</template>
<script>
import HRegionSelect from "@/components/HRegionSelect";
import { updateUserInfo, userDetail, distributionCapacity } from "@/api/user";
import PayModel from "@/components/PayModel";
import StoragePayModel from "@/components/StoragePayModel";
import { validatephone } from "@/utils/validate";

export default {
  components: { HRegionSelect, PayModel, StoragePayModel },
  computed: {
    userId: {
      get() {
        if (this.$route.query.userId != undefined) {
          return parseInt(this.$route.query.userId);
        }
        return 0;
      },
    },
  },
  data() {
    let phoneCheck = (rule, value, callbackFn) => {
      // const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!validatephone(value)) {
        callbackFn(this.$t("form.common.field.phone.checkMessage"));
        return;
      }
      callbackFn();
    };
    return {
      form: {
        phone: "",
        gender: 1,
      },
      userInfo: {},
      defaultValue: [],
      rules: {
        phone: [
          {
            required: true,
            message: this.$t("form.userDetail.form.field.mobile.message"),
            trigger: "blur",
          },
          { validator: phoneCheck, trigger: "blur" },
        ],
        company: [
          {
            required: true,
            message: this.$t("form.userDetail.form.field.company.message"),
            trigger: "blur",
          },
        ],
        linkman: [
          {
            required: true,
            message: this.$t("form.userDetail.form.field.contact.message"),
            trigger: "blur",
          },
        ],
        child_limit:[
          {
            required: true,
            message: this.$t("form.user.field.childLimit.message"),
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: this.$t("form.userDetail.form.field.address.message"),
            trigger: "blur",
          },
        ],
        email: [
          {
            type: "email",
            message: this.$t("form.userDetail.form.field.email.checkMessage"),
            trigger: "blur",
          },
        ],
      },
      capacityVisible: false,
      renewVisible: false,
      storageVisible: false,
      storeTypeArr:[
        {
          value:0,
          label:'請選擇品牌'
        },
        {
          value:1,
          label:'大家房屋'
        },
        {
          value:2,
          label:'住商不動產'
        },
      ],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.userInfo = {};
      userDetail({ id: this.userId }).then((res) => {
        this.form = res.data;
        this.userInfo = { ...res.data };
        this.userInfo.expire_time = this.userInfo.expire_time.substring(0, 11);
        this.userInfo.create_time = this.userInfo.create_time.substring(0, 11);
        this.defaultValue = res.data.parent_regoin;
      });
    },
    handleSubmit() {
      // e.preventDefault();
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          updateUserInfo(this.form).then((res) => {
            this.$message.success(this.$i18n.t("message.saveSuccess"));
            this.$router.push({
              path: "/agent/manager/userlist",
            });
          });
        }
      });
    },
    selectedData(val) {
      this.form.region = val;
    },
    renew() {
      this.renewVisible = true;
    },

    addCapacity() {
      this.storageVisible = true;
    },
    handleChangeBrand(value){
      this.form.store_type = value
      console.log(value)
    }
  },
};
</script>

<style scoped>
</style>
